<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('newStudentUnpaid.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('newStudentUnpaid.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('invoice.filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
          <!-- drawer -->
          <a-drawer
            :title="$t('invoice.filter')"
            placement="right"
            :closable="false"
            :visible="visible"
            @close="() => (visible = false)"
            :zIndex="1020"
            width="300px"
          >
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <a-select
                    style="width: 257px"
                    v-model="branch_id"
                    :options="branchs"
                    showSearch
                    mode="multiple"
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    :maxTagCount="1"
                    :maxTagTextLength="17"
                    :placeholder="$t('all')"
                  >
                  </a-select>
                </div>
              </div>
            </div>
          </a-drawer>
        </div>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'branch_name_en'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ is_external ? record.ext_card_number : record.card_number }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.student_name_kh }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.student_name_en }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.gender }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.phone }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.registered_date }}</td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>
<script>
import moment from 'moment'
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'newStudentUnpaid',
  data () {
    return {
      loading: false,
      visible: false,
      branchs: []
    }
  },
  created () {
    this.branch_id = [this.$store.state.authUser.default_branch_id]
    this.fetchData()
    this.getBranch()
  },
  computed: {
    ...mapState('newStudentUnpaid', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.newStudentUnpaid.search
      },
      set (newVal) {
        this.$store.commit('newStudentUnpaid/SET_SEARCH', newVal)
        this.$store.commit('newStudentUnpaid/RESET_CURRENT_PAGE')
      }
    },
    branch_id: {
      get () {
        return this.$store.state.newStudentUnpaid.branch_id
      },
      set (newValue) {
        this.$store.commit('newStudentUnpaid/SET_BRANCH_ID', newValue)
      }
    },
    columns () {
      return [
        { name: this.$t('newStudentUnpaid.studentId') },
        { name: this.$t('newStudentUnpaid.studentNameKh') },
        { name: this.$t('newStudentUnpaid.studentNameEn') },
        { name: this.$t('newStudentUnpaid.gender') },
        { name: this.$t('newStudentUnpaid.phone') },
        { name: this.$t('newStudentUnpaid.registered') }
      ]
    },
    is_external() {
      return this.$store.state.authUser.is_external
    },
  },
  methods: {
    fetchData (attributes = {}) {
      this.loading = true
      this.$store
        .dispatch(
          'newStudentUnpaid/fetch',
          Object.assign(
            {
              branch_id: this.branch_id
            },
            { ...attributes }
          )
        )
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    getBranch () {
      this.$store
        .dispatch('user/getBranch', {
          filter: {
            user_branches: true
          }
        })
        .then(response => {
          this.branchs = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search, branch_id: this.branch_id })
    }, 500),
    branch_id: debounce(function (value) {
      this.fetchData({ branch_id: value })
    }, 500),
    is_external: debounce(function() {
      this.fetchData({ branch_id: this.branch_id })
    }, 500),
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('newStudentUnpaid/RESET_STATE')
    next()
  }
}
</script>
